import api from "./api";

export const AuthService = {
  sendOtp: (email: string) =>
    api.post<{ otpToken: string }>("/auth/send-otp", { email }),

  verifyOtp: (email: string, otp: string, otpToken: string) =>
    api.post("/auth/verify-otp", { email, otp, otpToken }),

  resetPassword: (email: string, otp: string, otpToken: string, newPassword: string) =>
    api.post("/auth/reset-password", { email, otp, otpToken, newPassword }),
};
